module.exports = __webpack_public_path__ + "img/LanguageIcon.8b1d8df0.svg";